import { FieldArrayWithId } from "react-hook-form";
import { FieldValues } from "react-hook-form/dist/types/fields";
import { FieldArrayPath } from "react-hook-form/dist/types/path";

type CreateIdIndexMapProps<
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>
> = {
  fieldsFromFormContext: FieldArrayWithId<TFieldValues, TFieldArrayName>[];
};
// Creates a map that captures the relationship between the FieldArray id
// and the index in the React hook form FieldArray
const createIdIndexMapOfRhfFieldArray = <
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>
>({
  fieldsFromFormContext,
}: CreateIdIndexMapProps<TFieldValues, TFieldArrayName>) => {
  const idIndexMap: { [id: string]: number } = {};

  fieldsFromFormContext.forEach((element, index) => {
    idIndexMap[element.id] = index;
  });

  return idIndexMap;
};

type MapReactHookFormIndizesToGivenFieldArrayProps<
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>
> = {
  fieldsFromFormContext: FieldArrayWithId<TFieldValues, TFieldArrayName>[];
  filteredFields: FieldArrayWithId<TFieldValues, TFieldArrayName>[];
};
// Creates a map of id and index from all fields of the specified FieldArray fieldsFromFormContext
// The React Hook form indexes are assigned to the filtered fields based on the ID
export const mapReactHookFormIndizesToGivenFieldArray = <
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>
>({
  fieldsFromFormContext,
  filteredFields,
}: MapReactHookFormIndizesToGivenFieldArrayProps<TFieldValues, TFieldArrayName>) => {
  const indexedMap = createIdIndexMapOfRhfFieldArray<TFieldValues, TFieldArrayName>({
    fieldsFromFormContext,
  });

  const fieldsWithIndexFromRhfFieldArray: FieldArrayWithId<TFieldValues, TFieldArrayName>[] = [];

  filteredFields.forEach((item) => {
    fieldsWithIndexFromRhfFieldArray[indexedMap[item.id]] = item;
  });

  return fieldsWithIndexFromRhfFieldArray;
};
